import React, { Component } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Image from 'react-bootstrap/Image';
import api from '../../services/api';
import ReactHtmlParser from 'react-html-parser';
import { Link } from 'react-router-dom';

export default class Courses extends Component{
   // executa após o componente ser ativado
   componentDidMount (){
      this.loadDados();
   }

   // carrega os dados da api... promisse
   loadDados = async () =>{
      const {data} = await api.get('/curso?per_page=4');
      this.setState({ dados: data });
   }

     // armazena os dados no estado
     state = {
      dados: [
      {
         title:{
            rendered: ' '
         },
         excerpt:{
            rendered: ' '
         },
         imagem_destacada:{
            guid: ' '
         }
      }
      ],
   }

    // renderiza o componente 
    render(){
      return (    
         <div>
            <h2>Cursos</h2><hr />
            <Link to="/cursos">
               <small>veja +</small>
            </Link>
               <Row className="mt-4">
                  { this.state.dados.map ( (dado, index) => (
                     <Col key={index} sm={6} lg={3} className="mb-4">
                        <Link to={`/curso/${dado.slug}`} className="link">
                           <Image src={dado.imagem_destacada.guid} className="img-fluid rounded mb-2" />
                           <p><strong>{dado.title.rendered}</strong></p>                           
                           { ReactHtmlParser(dado.excerpt.rendered) }
                        </Link>
                     </Col>
                  )) }
               </Row>
         </div>
      )
   }
}